import { createContext } from 'react';

/** Imperative map actions the live MapView registers for out-of-tree callers. */
export interface MapActions {
    /** Flies the map back to the client network overview (the locate-network behaviour). */
    flyToNetwork: () => void;
}

export interface MapActionsContextValue {
    /** Called by MapView with its live actions on mount, and null on unmount. */
    register: (actions: MapActions | null) => void;
    /** Dispatches to the registered map's flyToNetwork; no-op when no map is registered. */
    flyToNetwork: () => void;
}

export const MapActionsContext = createContext<MapActionsContextValue | null>(null);
